export enum CustomerAuthenticationWorkspaceCapabilityUdoTemplateKey {
    customerOtp = "26c4d6cf-e486-4f7b-94c4-632205608861",
    customerOtpChannel = "e0183631-80c8-4b83-93b8-1ae388d04e45",
}
